/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'approversUserGroupArea';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'globalUserGroupApproverByArea';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'approverUserGroupArea';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'approversUserGroupArea';

/** Default list sort — matches legacy `useManageUserGroupApproverArea`. */
export const DEFAULT_ORDER_BY = 'userGroup/name asc';
